// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../node_modules/rescript/lib/es6/list.js";

function isUserAllowed(allowed_roles, user_roles) {
  return List.length(List.filter(function (user_role) {
                    return List.exists((function (allowed_role) {
                                  return allowed_role === user_role;
                                }), allowed_roles);
                  })(user_roles)) > 0;
}

var customerInfoEditRoles = {
  hd: "edit_customer_profile",
  tl: {
    hd: "customer_wallet_credit_debit",
    tl: /* [] */0
  }
};

var smsTemplateEditRoles = {
  hd: "city_admin",
  tl: /* [] */0
};

var partnerPenaltyDeleteRoles = {
  hd: "tele_agent",
  tl: /* [] */0
};

export {
  customerInfoEditRoles ,
  smsTemplateEditRoles ,
  partnerPenaltyDeleteRoles ,
  isUserAllowed ,
  
}
/* No side effect */
